import { render, staticRenderFns } from "./ActivityEmotionSpaceSection2.vue?vue&type=template&id=4b5e5882&scoped=true"
import script from "./ActivityEmotionSpaceSection2.vue?vue&type=script&lang=js"
export * from "./ActivityEmotionSpaceSection2.vue?vue&type=script&lang=js"
import style0 from "./ActivityEmotionSpaceSection2.vue?vue&type=style&index=0&id=4b5e5882&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e5882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5e5882')) {
      api.createRecord('4b5e5882', component.options)
    } else {
      api.reload('4b5e5882', component.options)
    }
    module.hot.accept("./ActivityEmotionSpaceSection2.vue?vue&type=template&id=4b5e5882&scoped=true", function () {
      api.rerender('4b5e5882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/ HundredDayOath/compoents/model/ActivityEmotionSpaceSection2.vue"
export default component.exports